import { useCallback } from "react";
import customLabels from "../field/customLabels";
import customHelperTexts from "../field/customHelperTexts";
import { useIntl } from "react-intl";

const regexCustomLabelsAndHelperTexts = /^\${(.*)}$/;

export function useCustomLabelsAndHelperTexts() {
	const intl = useIntl();

	const getCustomHelperTextsOrDefault: (helperText: string) => string =
		useCallback(
			(helperText: string) => {
				let ht = helperText;

				// See if there is a HelperText defined for "${SomeKey}" in customHelperTexts.ts:
				const isRegexMatch = regexCustomLabelsAndHelperTexts.test(ht);
				if (isRegexMatch) {
					const htTranslationId = ht.replace("${", "").replace("}", "");
					const htTranslationMessage = customHelperTexts[htTranslationId];
					if (htTranslationMessage) {
						ht = intl.formatMessage(htTranslationMessage);
					}
				}
				return ht;
			},
			[intl]
		);

	const getCustomLabelsOrDefault: (defaultLabel: string | undefined) => string =
		useCallback(
			(defaultLabel: string | undefined) => {
				if (!defaultLabel) return "";
				let lb: string = defaultLabel;

				// See if there is a HelperText defined for "${SomeKey}" in customHelperTexts.ts:
				const isRegexMatch = regexCustomLabelsAndHelperTexts.test(lb);
				if (isRegexMatch) {
					const lbTranslationId = lb.replace("${", "").replace("}", "");
					const lbTranslationMessage = customLabels[lbTranslationId];
					if (lbTranslationMessage) {
						lb = intl.formatMessage(lbTranslationMessage);
					}
				}
				return lb;
			},
			[intl]
		);

	return {
		getCustomLabelsOrDefault,
		getCustomHelperTextsOrDefault
	};
}
